import axios from 'axios';
import { isValidPostCode, isValidEmail } from '../common.js';

export default () => {
  return {
    baseUrl: 'https://members-api.parliament.uk/api/Members/',
    party: '',
    mpName: '',
    mpEmail: '',
    mpConstituency: '',
    mpPhotoUrl: '',
    mpNameAndFullTitle: '',

    open: false,
    message: '',
    firstName: '',
    lastName: '',
    email: '',
    address: '',
    townCity: '',
    postCode: '',
    feedback: '',
    processing: false,
    step: 1,
    openShareModal: false,
    linkCopied: false,

    init() {
      this.message = this.$refs.message.value;
      this.$watch(
        'firstName, lastName, email, address, townCity, postCode, message',
        () => {
          this.feedback = '';
        },
      );
      this.$watch('open', () => {
        if (this.open) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      });
      this.$watch('step', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    },

    reset() {
      this.party = '';
      this.mpName = '';
      this.mpEmail = '';
      this.mpConstituency = '';
      this.mpPhotoUrl = '';
      this.mpNameAndFullTitle = '';

      this.open = false;
      this.firstName = '';
      this.lastName = '';
      this.email = '';
      this.address = '';
      this.townCity = '';
      this.postCode = '';
      this.feedback = '';
      this.processing = false;
      this.step = 1;
      this.openShareModal = false;
      this.linkCopied = false;
    },
    async findMP() {
      this.processing = true;
      if (!isValidPostCode(this.postCode)) {
        this.processing = false;
        this.feedback = 'Please enter a valid postcode';
        this.$refs.search.focus();
        return;
      }

      if (this.postCode === 'Te1 1st') {
        this.dummyData();
        return;
      }

      const encodedPostCode = encodeURIComponent(this.postCode);

      const url = `${this.baseUrl}Search?Location=${encodedPostCode}&House=1&IsCurrentMember=true&skip=0&take=20`;

      const response = await fetch(url);
      const json = await response.json();
      if (json.items.length === 0) {
        this.feedback = "Couldn't find any MP for given Post Code";
        this.processing = false;
      }
      const data = json.items[0].value;
      this.mpName = data.nameDisplayAs;
      this.party = data.latestParty.name;
      this.mpNameAndFullTitle = `Dear ${data.nameFullTitle}`;
      this.mpConstituency = data.latestHouseMembership.membershipFrom;
      this.mpPhotoUrl = data.thumbnailUrl;
      this.mpEmail = await this.findMPEmail(data.id);

      if (!this.mpEmail) {
        this.feedback = `We were unable to find the email for the MP for this postcode. You can contact them <a class="underline font-semibold" href="https://members.parliament.uk/members/commons">directly here</a>
          or enter a new postcode`;
        this.processing = false;
        return;
      }
      this.processing = false;
      this.open = true;
    },
    async findMPEmail(id) {
      const url = `${this.baseUrl}${id}/Contact`;
      try {
        const response = await axios.get(url);
        const email = response.data.value.find(
          (element) => element.type === 'Parliamentary office',
        ).email;
        return email;
      } catch (error) {
        this.feedback = `Error fetching MP email: ${error}`;
        this.processing = false;
        return null;
      }
    },

    dummyData() {
      this.mpName = 'Mr. John Doe';
      this.party = 'Independend Party';
      this.mpNameAndFullTitle = 'Dear Mr. John Doe MP';
      this.mpConstituency = 'Uxbridge and South Ruislip';
      this.mpPhotoUrl = 'https://picsum.photos/seed/1719916688841/400/400';
      this.mpEmail = 'hello@thehive.app';
      this.processing = false;
      this.open = true;
    },
    async submit(event) {
      event.preventDefault();
      this.processing = true;
      if (!this.validateForm()) {
        this.processing = false;
        return;
      }
      const updatedMessage = `
Dear ${this.mpName},

${this.message}

Yours Sincerely,

${this.firstName} ${this.lastName}
`;

      const form = document.forms.namedItem('_writeToMPAction');
      const payload = new FormData(form);
      payload.set('message[body]', updatedMessage);

      const postUrl = form.action;

      try {
        await axios.post(postUrl, payload);
        this.feedback = 'Your message has been sent successfully.';
        this.step = 2;
      } catch (error) {
        this.feedback = `Something went wrong... ${error.response.data.message}`;
        this.processing = false;
        this.step = 1;
      }
    },

    validateForm() {
      if (!this.message) {
        this.processing = false;
        this.feedback = 'Please enter your message';
        this.$refs.message.focus();
        return false;
      }
      if (!this.firstName) {
        this.processing = false;
        this.feedback = 'Please enter your first name.';
        this.$refs.firstName.focus();
        return false;
      }
      if (!this.lastName) {
        this.processing = false;
        this.feedback = 'Please enter your last name.';
        this.$refs.lastName.focus();
        return false;
      }
      if (!isValidEmail(this.email)) {
        this.processing = false;
        this.feedback = 'Please enter a valid email address.';
        this.$refs.email.focus();
        return false;
      }
      if (!this.address) {
        this.processing = false;
        this.feedback = 'Please enter your address.';
        this.$refs.address.focus();
        return false;
      }
      if (!this.townCity) {
        this.processing = false;
        this.feedback = 'Please enter your town/city.';
        this.$refs.townCity.focus();
        return false;
      }
      if (!isValidPostCode(this.postCode)) {
        this.processing = false;
        this.feedback = 'Please enter your post code.';
        this.$refs.postCode.focus();
        return false;
      }
      return true;
    },
    copyLink() {
      this.$refs.link.select();
      this.$refs.link.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(this.$refs.link.value);
      this.linkCopied = true;
    },
  };
};
